import React, { useCallback, useMemo } from "react";
import { Form } from "react-final-form";
import classNames from "classnames";
import { findDictionaryItemByValue, resultElementSourceType } from "shared/rsDictionary";
import { isNotEmpty } from "utils/validate";
import Input from "rs-components/Input";
import SelectInput from "rs-components/Input/components/SelectInput";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import SimulationSourceFormField from "./components/SimulationSourceFormField";
import ProcessDataSourceFormField from "./components/ProcessDataSourceFormField";
import InsightSourceFormField from "./components/InsightSourceFormField";
import ResultDimensionDialog from "../../../ResultDimensionDialog";
import { ResultElementSourceType } from "store/rs-workspace/rs-workspace.types";
import * as styles from "./styles.module.scss";
export var FormField;
(function (FormField) {
    FormField["type"] = "type";
    //Simulation
    FormField["simulationId"] = "simulationId";
    FormField["adjustmentId"] = "adjustmentId";
    FormField["optimizationId"] = "optimizationId";
    //ProcessData
    FormField["processDataId"] = "processDataId";
    //Insight
    FormField["insightId"] = "insightId";
    FormField["inputSetId"] = "inputSetId";
    FormField["output"] = "output";
})(FormField || (FormField = {}));
const handleChangeType = (form) => ({ value: type }) => {
    if (type !== form.getFieldState(FormField.type)?.value) {
        form.restart({ type });
    }
};
const isSubmitDisabled = (values, valid) => {
    if (!values?.type || !valid) {
        return true;
    }
    switch (values.type) {
        case ResultElementSourceType.Simulation:
            return !isNotEmpty(values?.simulationId);
        case ResultElementSourceType.ProcessData:
            return !isNotEmpty(values?.processDataId);
        case ResultElementSourceType.Insight:
            return !isNotEmpty(values?.insightId);
        default:
            return true;
    }
};
const ResultElementBaseSourceSelect = ({ title, allowedTypes, initialValues, sourcesForFilter, withSimulationOptimization, onClose, onSubmit, restrictions, classes, getSubmitDisabledData, }) => {
    const selectedId = useMemo(() => {
        switch (initialValues?.type) {
            case ResultElementSourceType.Simulation:
                return initialValues?.simulationId;
            case ResultElementSourceType.ProcessData:
                return initialValues?.processDataId;
            case ResultElementSourceType.Insight:
                return initialValues?.insightId;
        }
    }, [initialValues]);
    const renderSourceFieldsBasedOnType = useCallback((values) => {
        switch (values.type) {
            case ResultElementSourceType.Simulation:
                return (React.createElement(SimulationSourceFormField, { withOptimization: withSimulationOptimization, sourcesForFilter: sourcesForFilter?.simulations }));
            case ResultElementSourceType.ProcessData:
                return React.createElement(ProcessDataSourceFormField, { sourcesForFilter: sourcesForFilter?.processData });
            case ResultElementSourceType.Insight:
                return React.createElement(InsightSourceFormField, { restrictions: restrictions });
        }
    }, [withSimulationOptimization, sourcesForFilter?.simulations, sourcesForFilter?.processData, restrictions]);
    return (React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues }, ({ handleSubmit, form, values, valid }) => {
        let submitDisabled = isSubmitDisabled(values, valid);
        let submitTitle = "";
        if (getSubmitDisabledData) {
            const data = getSubmitDisabledData(values);
            submitDisabled = data.disabled;
            submitTitle = data.message;
        }
        return (React.createElement(ResultDimensionDialog, { title: title, onClose: onClose, onClosed: () => form.reset(), onSubmit: handleSubmit, classes: { target: classNames(styles.target, classes?.target) }, placement: "bottom-start", selectedId: selectedId, submitDisabled: submitDisabled, submitTitle: submitTitle },
            React.createElement("div", { className: classNames(styles.root, classes?.root) },
                React.createElement("div", { className: styles.field },
                    React.createElement(Input, { component: SelectInput, placeholder: "Select", itemRenderer: SelectItemRenderer, autoFocus: true, classes: { component: styles.select, label: styles.labelType }, disableFormChange: true, onChange: handleChangeType(form), name: FormField.type, label: "Type", items: allowedTypes.map((type) => findDictionaryItemByValue(resultElementSourceType, type)), restrictions: { IsMandatory: true } })),
                React.createElement("div", { className: styles.body }, renderSourceFieldsBasedOnType(values)))));
    }));
};
export default ResultElementBaseSourceSelect;
